import React from "react";
import { cn } from "../../../common/u1/cn";
import { SparkleIcon, CheckCircleIcon } from "../../../../assets/ui/icons";

/* One benefit: a mark, a title, and a line of body copy. */
const TONES = {
  pitch: {
    color: "text-[var(--coral)]",
    render: () => <SparkleIcon size={20} />,
  },
  active: {
    color: "text-[var(--gold-deep)]",
    render: () => (
      <CheckCircleIcon
        size={20}
        fill="var(--gold-soft)"
        stroke="var(--gold-deep)"
        className=""
      />
    ),
  },
  unlock: {
    color: "text-[var(--success)]",
    render: () => (
      <CheckCircleIcon
        size={20}
        fill="var(--success-soft)"
        stroke="var(--success)"
        className=""
      />
    ),
  },
};

export const BenefitItem = ({ title, body, tone = "pitch", icon, className = "" }) => {
  const t = TONES[tone] || TONES.pitch;

  return (
    <div className={cn("flex items-start gap-3.5", className)}>
      <span className={cn("mt-px shrink-0 flex", t.color)}>{icon || t.render()}</span>
      <div className="min-w-0">
        <div className="mb-[3px] text-[15px] font-semibold text-[var(--ink)] font-sans">
          {title}
        </div>
        <div className="text-[13.5px] leading-[1.5] text-[var(--ink-2)] font-sans">{body}</div>
      </div>
    </div>
  );
};

/* The two-column grid the design lays benefits out in — one column below md. */
export const BenefitGrid = ({ benefits = [], tone = "pitch", className = "" }) => (
  <div className={cn("grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-x-11", className)}>
    {benefits.map((b) => (
      <BenefitItem key={b.title} title={b.title} body={b.body} tone={tone} />
    ))}
  </div>
);

export default BenefitItem;
